import hmktsLogo from '../../assets/hmkts_logo.png';
import loginLogoImg from '../../assets/LoginLogo.png';
import loginBackgroundImg from '../../assets/LoginBackground.jpg';
import faviconImg from '../../assets/favicon.png';
import bubblesPrimaryImg from '../../assets/bubbles_green.png';
import bubblesSecondaryImg from '../../assets/bubbles_blue.png';
import bubblesTertiaryImg from '../../assets/bubbles_orange.png';

export interface ThemeImageCollection {
    imageCollection: string;
}
export interface ThemeImages {
	logo: string;
	loginLogo: string;
	loginBackground: string;
	favicon: string;
	bubblesPrimary: string;
	bubblesSecondary: string;
	bubblesTertiary: string;
}

export const themeImages: ThemeImages = {
	logo: hmktsLogo,
	loginLogo: loginLogoImg,
	loginBackground: loginBackgroundImg,
	favicon: faviconImg,
	bubblesPrimary: bubblesPrimaryImg,
	bubblesSecondary: bubblesSecondaryImg,
	bubblesTertiary: bubblesTertiaryImg,
};
